/**
 * Upload API module — screenshot uploads.
 */
import { createUploadApi } from '@overlayqa/shared';
import { fetchApi } from './client';
import { log } from '@/lib/logger';

log.info('[api/upload] Module loaded');

// Dashboard fetchApi requires explicit token. Wrap the shared factory.
export const uploadApi = {
  screenshot: async (token: string | undefined, dataUrl: string) => {
    const api = createUploadApi((<T>(path: string, opts?: Record<string, unknown>) =>
      fetchApi<T>(path, { ...opts, token })) as Parameters<typeof createUploadApi>[0]);
    return api.screenshot(dataUrl);
  },
};
